export const selectors = {
    searchForm: '#news-search-form',
    publishedAfterInput: '.js-news-published-after',
    publishedBeforeInput: '.js-news-published-before',
    newsTypeSelect: '.js-news-type-select',
    resultsContainer: '.js-news-results',
    expandFilterButton: '.js-expand-filter',
    expandableFilter: '.js-expandable-filter-wrapper',
    clearAllButton: '.js-clear-all',
    clearDateButtons: '.js-clear-date',
    noResultsContainer: '.js-no-results',
    loadingSkeletons: '.js-news-skeletons'
};

const searchForm = document.querySelector(selectors.searchForm);

export const elements = {
    searchForm: searchForm,
    publishedAfterInput: document.querySelector(selectors.publishedAfterInput),
    publishedBeforeInput: document.querySelector(selectors.publishedBeforeInput),
    newsTypeSelect: document.querySelector(selectors.newsTypeSelect),
    resultsContainer: document.querySelector(selectors.resultsContainer),
    expandFilterButton: searchForm?.querySelector(selectors.expandFilterButton),
    expandableFilter: searchForm?.querySelector(selectors.expandableFilter),
    clearAllButton: searchForm?.querySelector(selectors.clearAllButton),
    clearDateButtons: searchForm?.querySelectorAll(selectors.clearDateButtons),
    noResultsContainer: document.querySelector(selectors.noResultsContainer),
    loadingSkeletons: document.querySelector(selectors.loadingSkeletons),
};
